module.exports = __webpack_public_path__ + "static/media/animation_300_google.ffd72ebf.gif";